import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiWorker } from '../api/worker';
import { NotificationPreference, PreferencesResponse, PreferencesUpdateRequest } from '../types';
import toast from 'react-hot-toast';

export const useNotificationPreferences = () => {
  return useQuery<PreferencesResponse>({
    queryKey: ['notification-preferences'],
    queryFn: () => 
      apiWorker.get('/api/users/me/preferences')
        .then(r => r.data),
  });
};

export const useUpdateNotificationPreference = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PreferencesUpdateRequest) => 
      apiWorker.patch('/api/users/me/preferences', data)
        .then(r => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notification-preferences'] });
      toast.success('Notification preferences updated');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || 'Failed to update notification preferences');
    },
  });
};
